import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Remembers (per browser tab) where a visitor came from and which page they
// were reading, so a signup can be credited to e.g. "this post, via Facebook".
// sessionStorage can throw in some private modes — tracking is best-effort.
const LAST_PAGE_KEY = 'signupLastPage';
const REFERRER_KEY = 'signupEntryReferrer';

function safeGet(key) {
  try { return sessionStorage.getItem(key); } catch (e) { return null; }
}

function safeSet(key, value) {
  try { sessionStorage.setItem(key, value); } catch (e) { /* ignore */ }
}

// Rendered once inside the router.
export function SignupRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // The outside site this visit started from (facebook.com, google.com, …),
    // recorded once per tab. In-app navigation never changes document.referrer.
    if (safeGet(REFERRER_KEY) === null) {
      let referrer = '';
      try {
        const host = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, '') : '';
        if (host && host !== window.location.hostname.replace(/^www\./, '')) referrer = host;
      } catch (e) { /* malformed referrer */ }
      safeSet(REFERRER_KEY, referrer);
    }
  }, []);

  useEffect(() => {
    if (location.pathname !== '/subscribe' && !location.pathname.startsWith('/admin')) {
      safeSet(LAST_PAGE_KEY, location.pathname + location.search);
    }
  }, [location]);

  return null;
}

// Fields to send with a signup. `page` overrides the remembered last page.
export function signupTrackingFields(source, page) {
  return {
    signup_source: source,
    signup_page: page || safeGet(LAST_PAGE_KEY) || null,
    signup_referrer: safeGet(REFERRER_KEY) || null,
  };
}
